<div class="theme-toggle-container" *ngIf="isOnCollectionRoute">
    <button class="theme-btn" [class.active]="isDark" [disabled]="isDisabled"
        (click)="setTheme('dark-theme')" aria-label="Switch to dark mode">
        Dark
    </button>
    <button class="theme-btn" [class.active]="isLight" [disabled]="isDisabled"
        (click)="setTheme('light-theme')" aria-label="Switch to light mode">
        Light
    </button>
</div>